import { bl_inv_stock_level_monitoring_event_company_link_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class StockLevelMonitoringEventCompanyLinkModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_event_company_link: bl_inv_stock_level_monitoring_event_company_link_RowClass = new bl_inv_stock_level_monitoring_event_company_link_RowClass();
}
